import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, isRef as _isRef, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "d-flex flex-column h-100"
}
const _hoisted_2 = {
  class: "pl-3 pr-2 pt-2 pb-2",
  style: {"border-bottom":"1px solid var(--el-border-color)"}
}
const _hoisted_3 = { class: "d-flex align-items-center" }
const _hoisted_4 = { class: "m-0 flex-fill" }
const _hoisted_5 = { class: "flex-fill position-relative" }
const _hoisted_6 = {
  key: 1,
  class: "mt-4 text-center"
}

import SideMenuCard from "~/operatorApplication/vue/dialogs/dialog/sidemenu/SideMenuCard.vue";
import {computed, ref} from "vue";
import {ClientUserdataStore} from "~/operatorApplication/ts/store/ClientUserdataStore";
import MyLoader from "~/cabinet/vue/interface/data/MyLoader.vue";
import DialogChatArea from "~/operatorApplication/vue/dialogs/dialog/DialogChatArea.vue";
import FontAwesomeIcon from "~/cabinet/vue/interface/icon/FontAwesomeIcon.vue";
import {toggleArrayElement} from "~/ts/library/ToggleArrayElement";
import {__} from "~/ts/library/Translate";
import {getSclon} from "~/ts/vuePlugins/NumbersPlugin";
import CrossOperatorConversationConfigDialog
    from "~/operatorApplication/vue/dialogs/dialog/sidemenu/crossOperatorConversation/CrossOperatorConversationConfigDialog.vue";



import {defineComponent} from 'vue';


const __default__ = defineComponent({
    name: "OperatorApplicationCrossOperatorConversation"
});


export default /*@__PURE__*/_defineComponent({
  ...__default__,
  props: {
    client: {},
    buddyList: {},
    site: {}
  },
  setup(__props: any) {

let props = __props;

let conversationClient = computed(() => {
    let username = props.client.crossOperatorConversationUsername;
    if (username) {
        return ClientUserdataStore.getByUsername(username, true);
    }
    return null;
});


let operatorCount = computed(() => {
    let result: string[] = [];
    let params = conversationClient.value?.crossOperatorConversationParams;
    if (params) {
        for (let login of params.operatorLogins) {
            if (props.site.operators.includes(login)) {
                toggleArrayElement(result, login, true);
            }
        }
        for (let groupId of params.operatorGroupIds) {
            let group = props.site.groups.find(group => group.id === groupId);
            if (group) {
                for (let operator of group.operators) {
                    if (props.site.operators.includes(operator)) {
                        toggleArrayElement(result, operator, true);
                    }
                }
            }
        }
    }
    return result.length;
});

let paramsDialogVisible = ref(false);

function openParamsDialog() {
    paramsDialogVisible.value = true;
}


return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createBlock(SideMenuCard, {
    class: "h-100 p-2",
    "card-class": "copilot-chat-wrapper h-100 overflow-hidden",
    "without-padding": ""
  }, {
    default: _withCtx(() => [
      (__props.client.crossOperatorConversationUsername)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            (_unref(conversationClient))
              ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                  _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", _hoisted_3, [
                      _createElementVNode("h5", _hoisted_4, _toDisplayString(_unref(getSclon)(
                                        _unref(operatorCount),
                                        _unref(__)("%d оператор", _unref(operatorCount)),
                                        _unref(__)("%d оператора", _unref(operatorCount)),
                                        _unref(__)("%d операторов", _unref(operatorCount))
                                    )), 1),
                      _createElementVNode("div", null, [
                        _createVNode(_component_el_button, { onClick: openParamsDialog }, {
                          default: _withCtx(() => [
                            _createVNode(FontAwesomeIcon, { icon: "cog" })
                          ]),
                          _: 1
                        }),
                        (_unref(paramsDialogVisible))
                          ? (_openBlock(), _createBlock(CrossOperatorConversationConfigDialog, {
                              key: 0,
                              visible: _unref(paramsDialogVisible),
                              "onUpdate:visible": _cache[0] || (_cache[0] = ($event: any) => (_isRef(paramsDialogVisible) ? (paramsDialogVisible).value = $event : paramsDialogVisible = $event)),
                              userdata: _unref(props).client,
                              "current-params": _unref(conversationClient)?.crossOperatorConversationParams
                            }, null, 8, ["visible", "userdata", "current-params"]))
                          : _createCommentVNode("", true)
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_5, [
                    _createVNode(DialogChatArea, {
                      class: "absolute-full-size",
                      userdata: _unref(conversationClient),
                      "buddy-list": __props.buddyList,
                      cobrowse: false,
                      "hide-top-menu": "",
                      "disable-background": "",
                      "short-message-margin": ""
                    }, null, 8, ["userdata", "buddy-list"])
                  ])
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  _createVNode(MyLoader, { big: "" })
                ]))
          ], 64))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})